import Vue from "vue";
import Vuex from "vuex";

import Topicos from "@/data/topicos.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    topicos: Topicos,
    showMenuDrawer: false,
    showWelcomeBack: false,
    showCongratulations: false,
    showGlossario: false,

    progresso_topicos: {
      topico_01: false,
      topico_02: false,
      topico_03: false,
      atividade_1_topico_01: false,
      atividade_1_topico_03: false,
      studentName: "",
      LMS_Progress: 0,
      completion_status: "",
    },
  },
  mutations: {
    TOGGLE_SHOW_MENU_DRAWER(state) {
      state.showMenuDrawer = !state.showMenuDrawer;
    },

    TOGGLE_WELCOME_BACK(state) {
      state.showWelcomeBack = !state.showWelcomeBack;
    },

    TOGGLE_CONGRATULATIONS(state) {
      state.showCongratulations = !state.showCongratulations;
    },

    TOGGLE_GLOSSARIO(state) {
      state.showGlossario = !state.showGlossario;
    },

    ADICIONAR_SCORE(state, payload) {
      state.progresso_topicos[payload] = true;

      // Filtrar somente os itens que contam para o progresso
      const progressoItens = Object.keys(state.progresso_topicos).filter(
        (key) => key.startsWith("topico") || key.startsWith("atividade")
      );

      // Calcular o progresso
      const progressoCompleto = progressoItens.filter((key) => state.progresso_topicos[key]).length;

      state.progresso_topicos.LMS_Progress = (progressoCompleto / progressoItens.length) * 100;
    }

  },
  actions: {},

  getters: {},

  modules: {},
});